export * from './avatar.module';

export * from './avatar.component';
export * from './avatar.directive';
export * from './dual-avatar.component';
